module.exports = __webpack_public_path__ + "static/img/IMG_20160821_135603.c6c87694.jpg";